import { Link, Typography, useTheme } from '@mui/material'

/* eslint-disable-next-line */
export interface FooterProps {}

export function Footer(props: FooterProps) {
  // const theme = useTheme()
  return (
    <Typography
      sx={{
        // position: 'relative',
        // bottom: 0,
        // left: 0,
        // width: '100%',
        textAlign: 'center',
        padding: 4,
        background: (theme) => theme.palette.grey['300'],
        // marginTop: 2,

        flexShrink: 0,
      }}
    >
      For access or to get started with an integration, please contact{' '}
      <Link href="mailto:sales@sendhub.com">sales@sendhub.com</Link>. For
      technical support related questions, please email{' '}
      <Link href="mailto:support@sendhub.com">support@sendhub.com</Link>. You
      can also text us at <Link href="tel:844-736-3482">844-SENDHUB</Link>,
      that's <Link href="tel:844-736-3482">844-736-3482</Link>.
    </Typography>
  )
}

export default Footer
